import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            datePointDelivered: yup.string().required(__(`form.datePointDelivered.error`)),
            comment: yup.string().required(__(`form.comment.error`)),
        })
    )
}

export default validators
